import * as tslib_1 from "tslib";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import SelectQuestionBox from "./SelectQuestionBox.vue";
import SortableList from './SortableList.vue';
import SortableItem from './SortableItem.vue';
import PaperHead from "./PaperHead.vue";
import PointContainer from "./PointContainer.vue";
import QuestionContent from "./QuestionContent.vue";
import QuestionSetScore from "./QuestionSetScore.vue";
import QuestionHandle from "./QuestionHandle.vue";
import SystemSelect from "./SystemSelect.vue";
import SystemRule from "./SystemRule.vue";
import { TestPaperEditorModule } from "@/store/modules/test-paper-editor";
import { AppModule } from "@/store/modules/app";
import { getQuestionsDetail, getRandomQuestionList } from "@/api/question";
import { saveTestPaper } from "@/api/test-paper";
let PaperOrganize = class PaperOrganize extends Vue {
    constructor() {
        super(...arguments);
        this.has_user = 0;
        this.isEditList = false;
        this.loading = false;
        this.showBatchSetScoreDialog = false;
        this.showHandleSelectBox = false;
        this.system = {
            showSystemSelectBox: false,
            showSystemRuleBox: false,
            quesSelectedStatus: {}
        };
        this.showRandomSetting = false;
        this.checkedStatus = {
            checkedKeys: []
        };
        this.selectedIndex = 0;
        this.canCreate = true;
    }
    get questionList() {
        return TestPaperEditorModule.questionList;
    }
    set questionList(questions) {
        TestPaperEditorModule.setQuestionList(questions);
    }
    get baseInfo() {
        return TestPaperEditorModule.baseInfo;
    }
    // get ranDetails() {
    //   return TestPaperEditorModule.ranDetails
    // }
    get questionsId() {
        return this.questionList.map((ques) => ques.id);
    }
    get questionTypeList() {
        const questionTypeList = [
            {
                questionTypeText: "单选",
                type: 0,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "多选",
                type: 1,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "判断",
                type: 3,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "填空",
                type: 4,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "问答",
                type: 2,
                num: 0,
                pointStatusArr: []
            },
            // {
            //   questionTypeText: "不定项选择",
            //   type: 5,
            //   num: 0,
            //   pointStatusArr: []
            // },
            {
                questionTypeText: "材料",
                type: 6,
                num: 0,
                pointStatusArr: []
            }
        ];
        this.questionList.forEach((ques) => {
            const type = questionTypeList.find((item) => item.type === ques.type);
            type.num++;
            type.pointStatusArr.push({
                type: ques.type,
                answer: ques.correct_answer,
                id: ques.id,
                score: ques.score,
                everyBlankScore: 4 === ques.type ? ques.everyBlankScore : ques.score,
                omitScore: ques.omitScore,
                omitType: ques.omitType
            });
        });
        return questionTypeList;
    }
    get paperScore() {
        let score = 0;
        for (let i = 0; i < this.questionList.length; i++) {
            score += Number(this.questionList[i].score) || 0;
        }
        score = 10 * Number(score.toFixed(1)) / 10;
        return score;
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    handlePointArrChange(questionTypes) {
        const ruleList = [];
        questionTypes.forEach((type) => {
            if (type.num > 0) {
                const isDifferentScore = type.pointStatusArr.some((ques, _, arr) => ques.score !== arr[0].score);
                const rule = {
                    availableNum: type.num,
                    type: type.type,
                    selectedNum: 0,
                    isDifferentScore,
                    questionScore: 0
                };
                if (!rule.isDifferentScore) {
                    rule.questionScore = type.pointStatusArr[0].score;
                }
                ruleList.push(rule);
            }
        });
        // if (this.ranDetails.length === ruleList.length && this.ranDetails.length > 0) {
        //   var _ruleList = [];
        //   this.ranDetails.forEach((e) => {
        //     ruleList.forEach((t) => {
        //       e.type == t.type && _ruleList.push(t)
        //     })
        //   })
        //   ruleList = _ruleList
        // }
        TestPaperEditorModule.setRuleList(ruleList);
    }
    batchSetScoreFunc() {
        console.log("点击批量设置分值");
        if (this.questionList.length !== 0) {
            this.baseInfo.participateCount > 0
                ? this.$message.error("有人参与的考试禁止批量设置分值")
                : this.showBatchSetScoreDialog = !0;
        }
    }
    preStep() {
        this.$router.push({
            name: "TestPaperEdit",
            query: {
                step: '1',
                paper_id: this.baseInfo.paperId,
                exam_id: this.$route.query.exam_id || ''
            }
        });
    }
    editList(index, question) {
        // console.log("是否点击了编辑题目");
        sessionStorage.setItem('from-router', JSON.stringify({
            name: 'TestPaperEdit',
            query: {
                step: '2',
                paper_id: this.baseInfo.paperId || '',
            }
        }));
        this.$router.push({
            query: {
                step: this.$route.query.step || '1',
                paper_id: this.baseInfo.paperId || '',
                is_edit: '1',
                type: question.type,
                question_id: question.id,
                exam_id: this.$route.query.exam_id || ''
            }
        });
        // window.parent.postMessage({
        //   cmd: 'goEditQuestion',
        //   params: {}
        // }, window.location.origin)
    }
    // randomSettingDialog() {
    //   this.showRandomSetting = !0
    // }
    // setRandomRuleConfirm(e) {
    //   var t = e.question_disorder
    //     , n = e.option_disorder
    //     , r = e.question_random
    //     , i = e.ruleList;
    //   if (console.log("随机设置确认"),
    //     this.setQuestionRandom(r),
    //     this.setRuleList(i),
    //     this.setOptionDisorder(n),
    //     this.setQuestionDisorder(t),
    //     this.showRandomSetting = !1,
    //     r) {
    //     var o = [];
    //     i.forEach((function (e) {
    //       var t = {
    //         type: e.type,
    //         num: Number(e.selectedNum)
    //       };
    //       o.push(t)
    //     }
    //     )),
    //       this.setRanDetails(o)
    //   }
    // }
    handlePaperParams() {
        const _quesList = [];
        this.questionList.forEach((ques) => {
            const _ques = {
                id: ques.id,
                score: ques.score,
                type: ques.type,
            };
            if (ques.type == 1 || ques.type == 5) {
                _ques.omitScore = ques.omitScore;
                _ques.omitType = ques.omitType;
            }
            else if (ques.type == 4) {
                _ques.everyBlankScore = ques.everyBlankScore;
            }
            else if (ques.type == 6 && ques.subQuestionList) {
                _ques.subQuestionList = [];
                ques.subQuestionList.forEach((subQues) => {
                    const _subQues = {
                        id: subQues.id,
                        score: subQues.score,
                        type: subQues.type,
                    };
                    if (subQues.type == 1 || subQues.type == 5) {
                        _subQues.omitScore = subQues.omitScore;
                        _subQues.omitType = subQues.omitType;
                    }
                    else if (subQues.type == 4) {
                        _subQues.everyBlankScore = subQues.everyBlankScore;
                    }
                    _ques.subQuestionList.push(_subQues);
                });
            }
            _quesList.push(_ques);
        });
        const data = {
            title: this.baseInfo.paperTitle,
            categoryId: this.baseInfo.paperLibraryId,
            questionList: _quesList,
        };
        // if (this.baseInfo.question_random) {
        //   var n = [];
        //   this.baseInfo.ruleList.forEach((function (e) {
        //     var t = {
        //       type: e.type,
        //       num: Number(e.selectedNum),
        //       score: e.questionScore
        //     };
        //     n.push(t)
        //   }
        //   )),
        //     data.ran_details = n
        // } else {
        //   data.question_disorder = this.baseInfo.question_disorder
        //   data.option_disorder = this.baseInfo.option_disorder;
        // }
        return data;
    }
    async createTestPaper() {
        if (this.questionList.length == 0) {
            return this.$message.error("请先选择题目");
        }
        if (this.canCreate) {
            this.canCreate = false;
            const params = this.handlePaperParams();
            try {
                await saveTestPaper(params);
                // if (this.gooseClass) {
                //   window.parent.postMessage({
                //     cmd: 'cancelEditPaper',
                //     params: {}
                //   }, window.location.origin)
                // }
                // this.$router.push({ name: "TestPaper" })
                this.$emit('confirm');
            }
            catch (_) { }
            finally {
                this.canCreate = true;
            }
        }
    }
    async editTestPaper() {
        if (this.questionList.length == 0) {
            return this.$message.error("请先选择题目");
        }
        const params = this.handlePaperParams();
        params.id = this.baseInfo.paperId;
        // paperData.participateCount = this.baseInfo.participateCount
        try {
            await saveTestPaper(params);
            const examId = this.$route.query.exam_id;
            if (examId) {
                // if (this.gooseClass) {
                //   window.parent.postMessage({
                //     cmd: 'cancelEditPaper',
                //     params: {}
                //   }, window.location.origin)
                // }
                // window.location.href = `editExam?exam_id=${examId}&paperId=${paperId}&step=2`
            }
            else {
                // this.$router.push({ name: "TestPaper" })
                this.$emit('confirm');
            }
        }
        catch (_) { }
    }
    handleSystemSelectQues() {
        // if (this.baseInfo.participateCount > 0) {
        //   this.$message.error("有人参与的考试禁止添加题目")
        // } else {
        //   // if (1 !== Number(this.baseInfo.question_random)) {
        //   //   this.system.showSystemSelectBox = true
        //   //   this.systemSelectQues.resetCheckedStatus()
        //   // } else {
        //   //   this.$message.error("随机试卷已开启，禁止添加题目")
        //   // }
        //   this.system.showSystemSelectBox = true
        //   this.systemSelectQues.resetCheckedStatus()
        // }
        this.system.showSystemSelectBox = true;
        this.systemSelectQues.resetCheckedStatus();
    }
    showSystemRuleFunc(data) {
        console.log("点击确认抽取分类弹框");
        this.system.showSystemSelectBox = false;
        this.system.showSystemRuleBox = true;
        this.checkedStatus = data.checkedStatus;
    }
    backToSystemSelect() {
        this.system.showSystemRuleBox = false;
        this.system.showSystemSelectBox = true;
        this.systemSelectQues.setCheckedStatus();
    }
    async systemConfirm(data) {
        this.system.showSystemRuleBox = false;
        const params = {
            categoryIds: this.checkedStatus.checkedKeys.join(','),
            questionIds: this.questionsId.join(','),
            questionNumList: data.ruleList.map(rule => ({
                type: rule.type,
                total: Number(rule.selectedNum)
            }))
        };
        this.loading = true;
        try {
            const res = await getRandomQuestionList(params);
            TestPaperEditorModule.handleQuestionsParams({
                type: "concat",
                list: res.data.data
            });
        }
        catch (_) { }
        finally {
            this.loading = false;
        }
    }
    handleSelectQues() {
        // if (this.baseInfo.participateCount > 0) {
        //   this.$message.error("有人参与的考试禁止添加题目")
        // } else {
        //   // if (1 !== Number(this.baseInfo.question_random)) {
        //   //   this.showHandleSelectBox = true
        //   // } else {
        //   //   this.$message.error("随机试卷已开启，禁止添加题目")
        //   // }
        //   this.showHandleSelectBox = true
        // }
        this.showHandleSelectBox = true;
    }
    async handleSelectConfirm(selectedList) {
        const ids = selectedList.map(q => q.id).join(',');
        try {
            const res = await getQuestionsDetail(ids);
            TestPaperEditorModule.handleQuestionsParams({
                list: res.data.data || [],
                type: "concat"
            });
        }
        catch (_) { }
        // TestPaperEditorModule.handleQuestionsParams({
        //   list: selectedList,
        //   type: "concat"
        // })
        this.showHandleSelectBox = false;
    }
    handleSelectCancel() {
        this.showHandleSelectBox = false;
    }
    watchInput(question, evt, omitType, material) {
        const target = evt.target;
        if (question.type === 4) {
            this.processScore(question, target.value, material);
        }
        else {
            if ((question.type === 1 || question.type === 5) && omitType) {
                question.omitScore = target.value;
                question.omitType = omitType;
            }
            this.processScore(question, "", material);
        }
    }
    processScore(question, score, material) {
        if (question.type === 4) {
            score = this.toFixedOne(score);
            question.everyBlankScore = score;
            question.score = score * question.optionList.length;
        }
        else {
            question.score = this.toFixedOne(score || question.score);
        }
        if (question.isMaterialQuestion) {
            console.log("材料题的处理分数改变");
            var i = 0;
            if (material.subQuestionList) {
                material.subQuestionList.forEach((ques) => {
                    i += ques.score;
                });
                material.score = i;
            }
        }
        question.omitScore = this.toFixedOne(question.omitScore);
        if (question.omitType === -1) {
            if (question.omitScore >= question.score
                && 0 !== question.score
                && typeof question.score === typeof question.omitScore) {
                question.omitScore = 0;
                this.$message.warning("漏选得分不能等于或超过全对的得分");
            }
        }
        else {
            const correctAnswerCount = question.optionList.filter(option => option.correct).length - 1;
            if (question.omitScore * correctAnswerCount > question.score
                && 0 !== question.score
                && typeof question.score === typeof question.omitScore) {
                question.omitScore = 0;
                this.isEditList
                    ? setTimeout(() => {
                        this.$message.warning("选项总得分不可大于题目总分数");
                    }, 2000)
                    : this.$message.warning("选项总得分不可大于题目总分数");
            }
        }
    }
    toFixedOne(val) {
        val = `${val}`;
        let result = val.replace(/^\D+|[^.\d]+/g, "");
        if (result && (result.indexOf(".") !== result.lastIndexOf(".") || !result.endsWith("."))) {
            const arr = result.split(".");
            if (arr.length >= 2) {
                result = arr.slice(0, 2).join(".");
            }
            result = Number.parseInt(`${10 * result}`) / 10;
        }
        if (Number.isNaN(result))
            result = 0;
        return result;
    }
    changeOmit(question, omitType) {
        // console.log("更改changeOmitchangeOmit")
        question.omitType = omitType;
        question.omitScore = 0;
    }
    changeScore(question) {
        if (!question.score) {
            question.score = 2;
            if (question.type == 4) {
                question.everyBlankScore = parseFloat(`${question.score / question.optionList.length}`);
            }
        }
        if (!question.omitScore) {
            question.omitScore = 0;
        }
    }
    // handleBatchSettingScore(e) {
    //   console.log("批量设置分数弹框是否生效");
    //   var t = this
    //     , n = e.settingQuestions
    //     , r = e.omitScoreSet;
    //   t.questions.forEach((function (e) {
    //     for (var i in n)
    //       i == e.type && (1 != e.type && 5 != e.type || (t.$set(e.omit_score[0], "score", r[i].score),
    //         t.$set(e.omit_score[0], "omit", r[i].omit)),
    //         6 !== e.type && t.processScore(e, n[i]))
    //   }
    //   ))
    // }
    async deleteQuestionType(data) {
        var type = data.type;
        try {
            await this.$alert('确定移除该题型吗？', {
                type: 'error',
            });
            // if (this.baseInfo.question_random != 1)
            //   this.multiDeleteQuestion(type);
            // else {
            //   this.randomPaperDeleteQuesFunc({
            //     deleteType: "multiple",
            //     questionType: type,
            //     questionIndex: ""
            //   })
            // }
            TestPaperEditorModule.multiDeleteQuestion(type);
        }
        catch (_) { }
    }
    async delList(index, question) {
        try {
            await this.$alert('确定移除该题目吗？', {
                type: 'error',
            });
            // console.log("删除删除删除删除")
            // if (baseInfo.question_random != 1)
            //   TestPaperEditorModule.singleDeleteQuestion(question);
            // else {
            //   this.randomPaperDeleteQuesFunc({
            //     deleteType: "single",
            //     questionType: question.type,
            //     questionIndex: index
            //   })
            // }
            TestPaperEditorModule.singleDeleteQuestion(index);
        }
        catch (_) { }
    }
    // randomPaperDeleteQuesFunc(e) {
    //   var t = e.deleteType
    //     , n = e.questionType
    //     , r = e.questionIndex
    //     , i = this.baseInfo.ruleList.some((function (e) {
    //       return e.type == n && e.selectedNum > 0
    //     }
    //     ));
    //   if (console.log(i, "是否是选中的随机类型"),
    //     i)
    //     if ("single" == t) {
    //       var o = 1
    //         , a = 0
    //         , s = 0;
    //       if (this.baseInfo.ruleList.forEach((function (e) {
    //         e.type == n && (a = e.availableNum,
    //           s = e.selectedNum)
    //       }
    //       )),
    //         a - o < s)
    //         return void this.$message.error("随机试卷题目不足，禁止移除该题目");
    //       this.singleDeleteQuestion(r)
    //     } else
    //       this.$message.error("随机试卷题目不足，禁止移除该题型");
    //   else
    //     "single" == t ? this.singleDeleteQuestion(index) : this.multiDeleteQuestion(n)
    // }
    onSelectItem(_, index) {
        this.selectedIndex = index;
    }
    onMoveUp(index) {
        TestPaperEditorModule.moveUp(index);
    }
    onMoveDown(index) {
        TestPaperEditorModule.moveDown(index);
    }
    onMoveTop(index) {
        TestPaperEditorModule.moveTop(index);
    }
};
tslib_1.__decorate([
    Ref()
], PaperOrganize.prototype, "systemSelectQues", void 0);
tslib_1.__decorate([
    Watch('questionTypeList', { deep: true })
], PaperOrganize.prototype, "handlePointArrChange", null);
PaperOrganize = tslib_1.__decorate([
    Component({
        name: 'PaperOrganize',
        components: {
            SelectQuestionBox,
            PaperHead,
            PointContainer,
            SortableList,
            SortableItem,
            QuestionContent,
            QuestionSetScore,
            QuestionHandle,
            SystemSelect,
            SystemRule,
        }
    })
], PaperOrganize);
export default PaperOrganize;
